void main()
{
    gl_FragColor = vec4(0.8,0.8,0.65,1.0);
}